import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AppShell, { storedSession } from '../components/AppShell';
import { AlexPickerDialog, AlexScheduleDialog, UnlinkedInterviews } from '../components/candidates/AlexDialogs';
import { canUseCandidates, isAdmin } from '../components/candidates/common';
import { btnPrimary, btnSecondary, card, ToastProvider } from '../components/ui/Kit';

// /technical-screen (bundle 4f): "Schedule interview" picks a candidate at AI screen "to schedule" (jobs you can work),
// then the one-step Alex screen dialog (time + time zone). Unlinked interviews wait here for a recruiter. The long
// schedule form is no longer in the navigation (its code stays in the dashboards).

function Body() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const [picking, setPicking] = useState(params.get('schedule') === '1');
  const [app, setApp] = useState(null);
  const [stamp, setStamp] = useState(0);
  const home = isAdmin() ? '/dashboard/company-admin' : '/dashboard/user';
  useEffect(() => {
    if (params.get('schedule') === '1') setParams((p) => { const n = new URLSearchParams(p); n.delete('schedule'); return n; }, { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="space-y-4" data-testid="technical-screen">
      <section className={card + ' p-5 flex flex-wrap items-center gap-3'}>
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl font-extrabold text-[#0F172A]">Technical Screen</h1>
          <p className="text-sm text-[#64748B]">Quali5d AI screens with Alex — pick a candidate who passed the recruiter screen, choose a time, done.</p>
        </div>
        <button className={btnSecondary} onClick={() => navigate(`${home}?menu=my-interviews`)}>Interviews</button>
        <button className={btnPrimary} onClick={() => setPicking(true)} data-testid="schedule-interview">Schedule interview</button>
      </section>
      <UnlinkedInterviews key={stamp} />
      {picking && <AlexPickerDialog onClose={() => setPicking(false)} onPick={(r) => { setPicking(false); setApp(r); }} />}
      {app && <AlexScheduleDialog appId={app.application_id} onClose={() => setApp(null)} onDone={() => { setApp(null); setStamp((n) => n + 1); }} />}
    </div>
  );
}

export default function TechnicalScreenPage() {
  const navigate = useNavigate();
  const allowed = canUseCandidates(storedSession().user);
  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/');
    else if (!allowed) navigate('/jobs');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!allowed) return null;
  return <ToastProvider><AppShell active="screen"><Body /></AppShell></ToastProvider>;
}
